import React from 'react';
import ReactDOM from 'react-dom';
// import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';
import App from './layouts/App';
import './index.css';

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN,
//   autoSessionTracking: true,
//   integrations: [new Integrations.BrowserTracing()],
//   release: process.env.REACT_APP_SENTRY_RELEASE,
//
//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// });

ReactDOM.render(<App />, document.getElementById('react-root'));
